/*
==============================================================================
MANTRAROMA CUSTOM
Version: 1.0.0
Datum: 15.09.2026
Zweck: Schaltet das EU-Gewährleistungslabel vor den Shopify-Checkout.
==============================================================================
*/

(() => {
  const gate = document.querySelector(
    '[data-mantraroma-eu-guarantee-gate]'
  );

  if (!gate) return;

  const dialog = gate.querySelector('[role="dialog"]');
  const continueButton = gate.querySelector(
    '[data-mantraroma-eu-guarantee-continue]'
  );
  const closeButtons = gate.querySelectorAll(
    '[data-mantraroma-eu-guarantee-close]'
  );

  let pendingCheckout = null;
  let previousFocus = null;

  const isCheckoutAnchor = (element) => {
    if (!(element instanceof HTMLAnchorElement)) return false;

    const url = new URL(element.href, window.location.origin);

    return (
      url.origin === window.location.origin &&
      /\/checkout\/?$/.test(url.pathname)
    );
  };

  const isCheckoutButton = (element) =>
    element instanceof HTMLButtonElement &&
    element.name === 'checkout' &&
    element.form;

  const openGate = (checkout) => {
    pendingCheckout = checkout;
    previousFocus = document.activeElement;

    continueButton.disabled = false;
    gate.hidden = false;

    document.documentElement.classList.add(
      'mantraroma-eu-guarantee-gate-open'
    );

    requestAnimationFrame(() => dialog.focus());
  };

  const closeGate = () => {
    gate.hidden = true;

    document.documentElement.classList.remove(
      'mantraroma-eu-guarantee-gate-open'
    );

    pendingCheckout = null;
    continueButton.disabled = false;

    if (previousFocus instanceof HTMLElement) {
      previousFocus.focus();
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('a, button');

      if (!trigger) return;

      if (isCheckoutAnchor(trigger)) {
        event.preventDefault();

        openGate({
          type: 'link',
          url: trigger.href
        });

        return;
      }

      if (isCheckoutButton(trigger)) {
        event.preventDefault();

        openGate({
          type: 'form',
          form: trigger.form,
          button: trigger
        });
      }
    },
    true
  );

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeGate);
  });

  continueButton.addEventListener('click', () => {
    if (!pendingCheckout) return;

    continueButton.disabled = true;

    if (pendingCheckout.type === 'link') {
      window.location.assign(pendingCheckout.url);
      return;
    }

    pendingCheckout.form.requestSubmit(
      pendingCheckout.button
    );
  });

  document.addEventListener('keydown', (event) => {
    if (gate.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeGate();
    }
  });
})();